import "./Header.css"
const Header= () => {

    return(
        <div className="header">
            <h1>CLARUS HOSPITAL</h1>
        </div>
    )
}

export default Header
